<script>
	import listBase from '@_system/components/base/list.vue'
	import Detail from './lib/detail.vue'
	export default {
		extends: listBase,
		name: 'postjobIndex',
		props: {

		},
		render(h) {
			this.$slots.plug = [
				<vxe-modal v-model={this.detailShow} width="1200" height="600" title={this.detailTitle} destroy-on-close show-footer size="mini">
					<Detail postjobid={this.postjobid} />
				</vxe-modal>,
				
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				componenttype:'system',
				moduleName: 'postjob',
				windowName: '岗位信息',
				detailShow: false,
				detailTitle: '详情',
				postjobid: 0
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			detail(row) {
				this.postjobid = row.id
				this.detailTitle = '详情：' + row.name
				this.detailShow = true
			},
			add() {
				import('@_system/components/forms/organization/postjob/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'postjob',
						id: 0,
						controlltype: 1,
						show: true,
					}
				})
			},
			edit(row) {
				import('@_system/components/forms/organization/postjob/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'postjob',
						id: row.id,
						controlltype: 2,
						show: true,
					}
				})
			},

		},
		components: {
			Detail
		}
	}
</script>
